import {TRANSLATION_NL} from 'src/environments/ett/translations/nl';
import {TRANSLATION_EN} from 'src/environments/ett/translations/en';
import {TRANSLATION_DE} from 'src/environments/ett/translations/de';
import {TRANSLATION_TR} from 'src/environments/ett/translations/tr';
import {TRANSLATION_PL} from 'src/environments/ett/translations/pl';
import {TRANSLATION_RO} from 'src/environments/ett/translations/ro';
import {TRANSLATION_PT} from 'src/environments/ett/translations/pt';

export const environment = {
    production: true,
    id: 'nl.ett.wave',
    version: '4.8.0',
    name: 'Iedereen veilig thuis',
    author: {
        name: 'Iedereen veilig thuis',
        email: 'info@ett-wave.nl',
        website: 'https://ett-wave.nl/',
    },
    deprecation: {
        domains: [],
        date: '2099-09-01T00:00:00',
    },
    host: 'vwwave',
    storage: '__wave',
    initialTheme: '',
    color: {
        primary: '#32659C',
        statusBar: {
            default: '#336699',
            overlay: '#14293D',
        },
    },
    supportedLanguages: [
        {
            value: 'nl',
            label: 'Nederlands',
            translationFile: TRANSLATION_NL,
        },
        {
            value: 'de',
            label: 'Deutsch',
            translationFile: TRANSLATION_DE,
        },
        {
            value: 'en',
            label: 'English',
            translationFile: TRANSLATION_EN,
        },
        {
            value: 'tr',
            label: 'Türkçe',
            translationFile: TRANSLATION_TR,
        },
        {
            value: 'pl',
            label: 'Polsku',
            translationFile: TRANSLATION_PL,
        },
        {
            value: 'ro',
            label: 'Romana',
            translationFile: TRANSLATION_RO,
        },
        {
            value: 'pt',
            label: 'Portugues',
            translationFile: TRANSLATION_PT,
        },
    ],
    api: 'https://ett-wave.nl',
    apiTimeout: 60000,
    msAuth: {
        tenantId: 'common',
        clientId: 'daf342c2-f68d-4b31-b7c3-283432905d36',
        keystoreHash: 'dT8/PwM6Pz8AZFY/Py5uTD9fZgINCg==',
        scopes: ['api://daf342c2-f68d-4b31-b7c3-283432905d36/default'],
        redirectUri: 'https://app.ett-wave.nl',
    },
    deeplinks: [
        'https://www.ett-wave.nl/deeplink/',
        'https://ett-wave.nl/deeplink/',
        'https://app.ett-wave.nl/deeplink/',
    ],
    whitelistedDomains: [
        'www.ett-wave.nl',
        'ett-wave.nl',
        'app.ett-wave.nl',
    ],
    privacyPolicyUrl: 'https://ett-wave.nl/documents/privacy-policy.html',
    instructionFilmUrl: '',
    applicationInsights: {
        instrumentationKey: '0e60aa15-c020-4e10-beb0-75193657fc95',
    },
};

